<div #content class="h-100 w-100">
  @if (!!currentTemplate) {
    <ng-container *ngTemplateOutlet="currentTemplate"></ng-container>
  }
</div>
@if (!alertPY && globalServiceService.role) {
  <div class="mode-provider-menu" style="margin: 10px -8px -10px 0;">
    <div class="container-fluid">
      @if (showModes) {
        @for (mode of templateModes; track mode) {
          <div class="row mb-1 d-flex align-items-center justify-content-center">
            @if (mode.text ==='Grafico de barras') {
              <button mat-mini-fab (click)="emitMode(mode)" data-title="Grafico de barras">
                <mat-icon>{{mode.icon}}</mat-icon>
              </button>
            }
            @if (mode.text ==='Tabla de Rangos' && country === 'AR' || mode.text ==='Tabla de Rangos' && country !== 'AR' && globalServiceService.nameModelIndicator !== 'Resumen de indicadores') {
              <button mat-mini-fab (click)="emitMode(mode)" data-title="Tabla de rangos">
                <mat-icon>{{mode.icon}}</mat-icon>
              </button>
            }
            @if (mode.text ==='Grafico de lineas') {
              <button mat-mini-fab (click)="emitMode(mode)" data-title="Grafico de lineas">
                <mat-icon>{{mode.icon}}</mat-icon>
              </button>
            }
            @if (mode.text ==='tabla lista de personas') {
              <button mat-mini-fab (click)="emitMode(mode)" data-title="Lista de personas">
                <mat-icon>{{mode.icon}}</mat-icon>
              </button>
            }
            @if (mode.text ==='tabla lista de indicadores') {
              <button mat-mini-fab (click)="emitMode(mode)" data-title="Lista de indicadores">
                <mat-icon>{{mode.icon}}</mat-icon>
              </button>
            }
          </div>
        }
      }
      <!-- <div class="row d-flex align-items-center justify-content-left">
      <img (click)="showModes = !showModes" src="{{urlAssets}}/icons/floating-button.png" alt="..." style="max-width: 60px;">
    </div> -->
  </div>
</div>
}

<!-- Paraguay inicio -->
@if (alertPY) {
  <div class="mode-provider-menu" style="margin: 10px 0px 10px 0;">
    <div class="container-fluid">
      @if (showModes) {
        @for (mode of templateModes; track mode) {
          <div class="row mb-1 d-flex align-items-center justify-content-center">
            @if (mode.text ==='Alertas') {
              <button mat-mini-fab (click)="emitMode(mode)" data-title="Alertas">
                <mat-icon>{{mode.icon}}</mat-icon>
              </button>
            }
            @if (mode.text ==='Grafico de barras Vertical') {
              <button mat-mini-fab (click)="emitMode(mode)" data-title="Grafico de barras Vertical">
                <mat-icon>{{mode.icon}}</mat-icon>
              </button>
            }
            @if (mode.text ==='Grafico de barras Horizontal') {
              <button mat-mini-fab (click)="emitMode(mode)" data-title="Grafico de barras Horizontal">
                <mat-icon style="transform: rotate(90deg)">{{mode.icon}}</mat-icon>
              </button>
            }
          </div>
        }
      }
      <!-- <div class="row d-flex align-items-center justify-content-left">
      <img (click)="showModes = !showModes" src="{{urlAssets}}/icons/floating-button.png" alt="..." style="max-width: 60px;">
    </div> -->
  </div>
</div>
}
<!-- Paraguay fin -->
